const initialState = {
  meta: {
    isTransactions: ''
  },
  data: {
    detail: {},
    transactions: [],
    page: {
      current_page: 1,
      next_page: 1,
      previous_page: 1,
      total_data: 0,
      total_pages: 0
    }
  }
}

export default (state = initialState, action) => {
  const { type, payload, others = {} } = action
  switch (type) {
    case 'SET_TRANSACTION_META':
      return {
        ...state,
        meta: {
          ...state.meta,
          [payload.field]: payload.payload,
          ...others
        }
      }
    case 'SET_TRANSACTION_DATA':
      return {
        ...state,
        data: {
          ...state.data,
          [payload.field]: payload.payload,
          ...others
        }
      }
    default:
      return state
  }
}
